import { FC } from 'react';
import FormatMoney from '../../../../../utils/FormatMoney';

interface Financeira {
    id: string | number;
    nome: string;
    valor?: number;
    parcela_min?: number | null;
    parcela_max?: number | null;
}

interface FinanceireLimitsHintProps {
    financeiras: Financeira[];
    isTotal: boolean;
}

const FinanceireLimitsHint: FC<FinanceireLimitsHintProps> = ({ financeiras, isTotal }) => {
    if (financeiras.length === 0) return null;

    return (
        <>
            {financeiras.map((f) => {
                const isSoma = f.nome.toUpperCase().startsWith('SOMA');
                const isPresenca = f.nome.toUpperCase().startsWith('PRESEN');

                if (isSoma || isPresenca) {
                    const maxParcela = isSoma ? f.valor : (f.parcela_max ?? f.parcela_min);
                    if (maxParcela == null) return null;
                    return (
                        <span key={f.id} className="step-params__hint">
                            {`${f.nome}: Valor máximo da parcela: ${FormatMoney(maxParcela)}`}
                        </span>
                    );
                }

                if (isTotal) {
                    if (f.valor == null) return null;
                    return (
                        <span key={f.id} className="step-params__hint">
                            {`${f.nome}: até ${FormatMoney(f.valor)}*`}
                        </span>
                    );
                }

                if (f.parcela_min == null && f.parcela_max == null) return null;

                return (
                    <span key={f.id} className="step-params__hint">
                        {`${f.nome}: ${
                            f.parcela_min != null && f.parcela_max != null
                                ? `${FormatMoney(f.parcela_min)} a ${FormatMoney(f.parcela_max)}`
                                : FormatMoney(f.parcela_min ?? f.parcela_max ?? 0)
                        }*`}
                    </span>
                );
            })}
        </>
    );
};

export default FinanceireLimitsHint;
